<app-full-page-message
  *ngIf="localService.isServiceProviderBlocked() || (interactionType == 2 && businessId != '' && businessId != '0' && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin))"></app-full-page-message>
<div
  *ngIf="!localService.isServiceProviderBlocked() && (interactionType != 2 || (interactionType == 2 && (businessId == '' || businessId == '0' || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin))))">
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.biz_payments">
    <app-business-deductive *ngIf="localService.loggedMember && businessId != '' && businessId != '0'"
      [currentBusinessId]="businessId" [businesses]="localService.loggedMember.businesses"></app-business-deductive>
    <div style="max-width:600px;" class="center">
      <div *ngIf="!isViewMode">
        <div class="banner row" *ngIf="newData">
          <div class="col-12">
            <div>
              <label>{{localService.languageContent.biz_payments.new_payment}}</label>
            </div>
            <div>
              <input autocomplete="off" [ngClass]="newData.v2 == '' ? '' : 'en'" type="text"
                id="{{elementIds.txt_title}}" [(ngModel)]="newData.v2"
                placeholder="{{localService.languageContent.biz_payments.title}}"
                title="{{localService.languageContent.biz_payments.title}}" />
            </div>
            <div>
              <textarea [ngClass]="newData.v3 == '' ? '' : 'en'" id="{{elementIds.txt_detail}}" rows="3"
                [(ngModel)]="newData.v3" placeholder="{{localService.languageContent.biz_payments.details}}"
                title="{{localService.languageContent.biz_payments.details}}"></textarea>
            </div>
            <div>
              <label style="font-weight: normal; margin-left: 15px;">
                <input type="checkbox" [(ngModel)]="isQrCode" (change)="onChange(1)" />
                <span class="normal_color">{{localService.languageContent.biz_payments.is_qr_code}}</span>
              </label>
              <button type="button" style="float:right;" class="btn btn-primary"
                [disabled]="newData.v2 == '' || newData.v3 == ''"
                (click)="onSave(newData,1)">{{localService.languageContent.common.add}}</button>
            </div>
          </div>
        </div>
        <div *ngIf="items">
          <div *ngFor="let item of items">
            <div class="banner row" style="margin-top:5px;">
              <div class="col-12">
                <div>
                  <input autocomplete="off" [ngClass]="item.v2 == '' ? '' : 'en'" type="text" [(ngModel)]="item.v2"
                    placeholder="{{localService.languageContent.biz_payments.title}}"
                    title="{{localService.languageContent.biz_payments.title}}" />
                </div>
                <div>
                  <textarea [ngClass]="item.v3 == '' ? '' : 'en'" rows="3" [(ngModel)]="item.v3"
                    placeholder="{{localService.languageContent.biz_payments.details}}"
                    title="{{localService.languageContent.biz_payments.details}}"></textarea>
                </div>
                <div>
                  <i class="material-icons button icon_adjust"
                    title="{{item.v6 == '1' ? localService.languageContent.common.make_inactive : localService.languageContent.common.make_active}}"
                    (click)="onSave(item,3)"
                    [ngStyle]="{'color': item.v6 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v6 == '1' ? "toggle_on"
                    : "toggle_off"}}</i>
                  <span class="normal_color"
                    *ngIf="item.v5 == '1'">&nbsp;&nbsp;{{localService.languageContent.biz_payments.is_qr_code}}</span>
                  <button style="float:right" type="button" class="btn btn-primary"
                    [disabled]="item.v2 == '' || item.v3 == ''"
                    (click)="onSave(item,14)">{{localService.languageContent.common.update}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isViewMode">
        <div *ngIf="items">
          <label>{{localService.languageContent.biz_payments.payment_details}}&nbsp;:&nbsp;</label>
          <span *ngIf="items.length == 0">{{localService.languageContent.biz_payments.not_found}}</span>
          <div style="margin-top:5px;" *ngFor="let item of items">
            <div class="box row en" *ngIf="item.v6 == '1'">
              <div class="col-12">
                <div>
                  <label>{{item.v2}}</label>
                </div>
                <div *ngIf="item.v5 != '1'">
                  {{item.v3}}
                </div>
                <app-qrcode-generator *ngIf="item.v5 == '1'" [value]="item.v3"
                  [categoryCode]="0"></app-qrcode-generator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>